
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import CustomChipLink from "@/components/CustomChipLink.vue";
import debounce from "debounce";
import { ROWS_PER_PAGE } from "@/utils/constants";

@Component({
  components: { CustomChipLink},
})
export default class UserKeyHoldingsTab extends Vue {

  get lang(): string {
    return this.$root.$i18n.locale;
  }

  @Prop({ default: null })
  public userId: number;

  @Watch("search", { immediate: false })
  public handlerSearch = debounce(this.getKeys, 500);

  @Getter private envCompanyId: number|null;

  private keyHoldings: object[] = [];
  private loading: boolean = false;
  private count: number = 0;
  private headers: object[] = [
    {value: "name", sortable: false},
    {value: "relay", sortable: false},
    {value: "category", sortable: false},
    {value: "startDate", sortable: false},
  ];
  private search: string = "";
  private pagination: {
    page: number,
    itemsPerPage: number,
  } = {
    page: 1,
    itemsPerPage: 10,
  };
  private ROWS_PER_PAGE = ROWS_PER_PAGE;

  @Watch("pagination", { immediate: false })
  private async getKeys(): Promise<void> {
    this.loading = true;
    this.$store.dispatch("users/getUserKeyHoldings", {
      userId: this.userId,
      companyId: this.envCompanyId,
      page: this.pagination.page,
      itemsPerPage: this.pagination.itemsPerPage,
      search: this.search,
    }).then((res) => {
      this.keyHoldings = res.rows;
      this.count = res.count;
    }).catch((error) => {
      this.$store.commit("alerts/displayHttpError", { error });
    }).finally(() => {
      this.loading = false;
      this.$emit("loaded");
    });
  }

  private clickRow(item) {
    return this.$router.push({name: "key", params: {id: item.Key.id}});
  }
}
